import React from "react";

const UsersIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99268 13.1724C11.0668 13.1724 13.6943 13.6382 13.6943 15.499C13.6943 17.3599 11.0843 17.839 7.99268 17.839C4.91768 17.839 2.29102 17.3774 2.29102 15.5157C2.29102 13.654 4.90018 13.1724 7.99268 13.1724Z"
        stroke={color}
        stroke-width="1.5"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99289 10.5166C5.97456 10.5166 4.33789 8.88075 4.33789 6.86242C4.33789 4.84409 5.97456 3.20825 7.99289 3.20825C10.0104 3.20825 11.6471 4.84409 11.6471 6.86242C11.6546 8.87325 10.0296 10.5091 8.01872 10.5166H7.99289Z"
        stroke={color}
        stroke-width="1.5"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7358 9.56814C15.07 9.38064 16.0975 8.23564 16.1 6.84981C16.1 5.48397 15.1042 4.35064 13.7983 4.13647"
        stroke={color}
        stroke-width="1.5"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4961 12.7769C16.7886 12.9694 17.6911 13.4227 17.6911 14.356C17.6911 14.9985 17.2661 15.4152 16.5794 15.676"
        stroke={color}
        stroke-width="1.5"
        strokeOpacity="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UsersIcon;
